import React from 'react';
import { Grid, IconButton, Typography, XCloseIcon } from '@metarouter-private/mr-mui';
import { useTestPipelineDrawerContext } from 'app/pipeline-details/StatusItem/TestPipelineDrawerContextProvider';
import PipelineIntegrationSelect from './PipelineIntegrationSelect';

export default function TestPipelineDrawerHeader() {
  const {
    drawer: { onClose },
  } = useTestPipelineDrawerContext();
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid container item xs={8}>
        <Typography variant="h6">Test Pipeline</Typography>
      </Grid>
      <Grid container item xs={3}>
        <PipelineIntegrationSelect />
      </Grid>
      <Grid item>
        <IconButton onClick={onClose} data-test-id="drawer-close-button">
          <XCloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}
